@if (label(); as label) {
  <label class="kt-form-label text-gray-900 font-medium" [for]="key">
    {{ label }}
  </label>
}

<div class="kt-form-control" [class.kt-input-group]="!!icon()">
  @if (icon(); as icon) {
    <span class="kt-input-addon kt-input-addon-icon" [ngClass]="getAddonSizeClass()">
      <app-icon class="text-gray-400" [icon]="icon" [size]="18" />
    </span>
  }

  <input
    #input
    [id]="key"
    class="kt-input"
    [ngClass]="[getSizeClass(), inputClass()]"
    [readOnly]="readOnly()"
    [attr.aria-invalid]="!!errorMessage"
    [name]="name()"
    [type]="type()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [maskito]="mask()"
    [value]="value()"
    (input)="handleChange($event)"
    (focus)="handleFocus($event)"
    (blur)="onTouched()"
  />
</div>

@if (description(); as description) {
  <div class="kt-form-description">{{ description }}</div>
}

<div class="kt-form-message">{{ errorMessage }}</div>
